import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ef018bd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ef018bd&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=5ef018bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef018bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef018bd')) {
      api.createRecord('5ef018bd', component.options)
    } else {
      api.reload('5ef018bd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ef018bd&scoped=true", function () {
      api.rerender('5ef018bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/index.vue"
export default component.exports